import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import type { FLEXIBLE_DURATION_RANGE } from 'constants/search'
import React from 'react'
import { useIntl } from 'react-intl'
import type { DurationOption } from './DurationPicker'
import DurationPicker from './DurationPicker'
import MonthPicker from './MonthPicker'

interface Props {
  onDurationChange?: (duration: FLEXIBLE_DURATION_RANGE) => void
  onMonthChange?: (monthOptions: string) => void
  onDatesChange?: () => void
  previouslySelectedDuration?: FLEXIBLE_DURATION_RANGE
  previouslySelectedMonths?: string
  durationOptionsCustom?: Array<DurationOption>
  showYearSelector?: boolean
}

function FlexibleDatePicker(props: Props) {
  const {
    onDurationChange,
    onMonthChange,
    previouslySelectedDuration,
    previouslySelectedMonths,
    durationOptionsCustom,
    showYearSelector,
  } = props
  const intl = useIntl()
  return (
    <Group direction="vertical" gap={24} horizontalAlign="center">
      <Group direction="vertical" gap={16} horizontalAlign="center">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'xFtiiq0QmRplZUNvwWbF',
            defaultMessage: 'How long?',
            description: 'Heading for duration selection in flexible date picker',
          })}
        </Heading>
        <DurationPicker
          durationOptionsCustom={durationOptionsCustom}
          previouslySelectedDuration={previouslySelectedDuration}
          onDurationChange={onDurationChange}
        />
      </Group>
      <Group direction="vertical" gap={16} horizontalAlign="center">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'VZI1AkaAOxtG_f7mac_2',
            defaultMessage: 'When?',
            description: 'Heading prompting the user to select preferred travel months in the flexible date search picker',
          })}
        </Heading>
        <MonthPicker
          previouslySelectedMonths={previouslySelectedMonths}
          onMonthChange={onMonthChange}
          showYearSelector={showYearSelector}
        />
      </Group>
    </Group>
  )
}

export default FlexibleDatePicker
